import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { BehaviorSubject, Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { Filter } from '../../interfaces/filter';

import { NotificationDTO, SuccessDTO } from '../../interfaces/models';
import { NotificationService } from './notification.service';

type SocketWithRemoveAllListeners = Socket & {
  removeAllListeners?: (eventName?: string) => void;
};

@Injectable()
export class NotificationUiService {
  constructor(
    private readonly socket: Socket,
    private readonly notificationService: NotificationService,
  ) {
    this.socketConnect();
  }

  private _notifications$: BehaviorSubject<NotificationDTO[]> = new BehaviorSubject<NotificationDTO[]>([]);

  get notifications$(): Observable<NotificationDTO[]> {
    return this._notifications$.asObservable();
  }

  get currentValue() {
    return this._notifications$.value;
  }

  addNotification(notificaiton: NotificationDTO) {
    const currentNotificaitons = this._notifications$.value;
    this.addNotificationList([notificaiton, ...currentNotificaitons]);
  }

  addNotificationList(notificaitons: NotificationDTO[]) {
    this._notifications$.next(notificaitons);
  }

  getAllNotificaitonsHttp(filter?: Filter) {
    return this.notificationService.getNotificationWebList(filter).pipe(
      tap(response => this.addNotificationList(response.data)),
      switchMap(() => this.notifications$)
    )
  }

  markAsViewed(id: number): Observable<SuccessDTO> {
    return this.notificationService.markAsViewed(id);
  }

  private socketConnect() {
    (this.socket as SocketWithRemoveAllListeners).removeAllListeners?.('client-notification-web');
    this.socket.on('client-notification-web', (data) => {
      // console.log("Wev", data);

      this.addNotification(data);
    });
  }
}
